// 修改 toggleCartDrawer 以控制遮罩
const originalToggleCartDrawer = toggleCartDrawer;
toggleCartDrawer = function(show) {
  const backdrop = document.getElementById('CartBackdrop');
  if (backdrop) {
    backdrop.classList.toggle('is-visible', show);
  }
  originalToggleCartDrawer(show);
};

// 点击遮罩关闭 Drawer
document.addEventListener('DOMContentLoaded', function () {
  const backdrop = document.getElementById('CartBackdrop');
  if (backdrop) {
    backdrop.addEventListener('click', function () {
      toggleCartDrawer(false);
    });
  }
});

// 打开或关闭右侧抽屉
function toggleCartDrawer(show) {
  const drawer = document.getElementById('CartDrawer');
  if (!drawer) return;

  drawer.classList.toggle('is-visible', show);
}

// 刷新 Mini Cart 抽屉内容，并返回 Promise
function refreshMiniCart() {
  const currentDrawer = document.getElementById('CartDrawer');
  if (currentDrawer) {
    currentDrawer.innerHTML = '<div class="drawer-loading" style="padding:20px;text-align:center;">Loading...</div>';
  }

  return fetch('/?section_id=drawer-cart')
    .then(response => response.text())
    .then(html => {
      const parser = new DOMParser();
      const doc = parser.parseFromString(html, 'text/html');
      const newDrawer = doc.getElementById('CartDrawer');

      if (newDrawer && currentDrawer) {
        currentDrawer.innerHTML = newDrawer.innerHTML;
      }
    })
    .catch(error => {
      console.error('🔴 Failed to refresh mini cart:', error);
    });
}

// 更新购物车 icon 数量
function updateCartIconCount() {
  fetch('/cart.js')
    .then(res => res.json())
    .then(cart => {
      const count = cart.item_count;
      document.querySelectorAll('.cart-count-number').forEach(el => {
        el.textContent = count;
      });
    })
    .catch(error => {
      console.error('🔴 Failed to update cart count:', error);
    });
}

// 显示 toast 提示
function showToast(message, isError = false) {
  const toast = document.createElement('div');
  toast.className = 'toast';
  toast.textContent = message;

  if (isError) toast.style.backgroundColor = '#c62828';

  document.body.appendChild(toast);

  setTimeout(() => toast.classList.add('show'), 100);
  setTimeout(() => {
    toast.classList.remove('show');
    setTimeout(() => toast.remove(), 300);
  }, 3000);
}

// 主逻辑
document.addEventListener('DOMContentLoaded', function () {
  const forms = document.querySelectorAll('form[data-add-to-cart], .ajax-add-to-cart-form');

  forms.forEach(form => {
    form.addEventListener('submit', function (e) {
      e.preventDefault();

      const formData = new FormData(form);

      fetch('/cart/add.js', {
        method: 'POST',
        body: formData,
        headers: { 'Accept': 'application/json' }
      })
        .then(res => res.json())
        .then(data => {
          console.log('✅ Added to cart:', data);
          updateCartIconCount();

          // 等待内容刷新后再显示抽屉
          refreshMiniCart().then(() => {
            toggleCartDrawer(true);
            showToast('Added to cart successfully!');
          });
        })
        .catch(error => {
          console.error('❌ Failed to add to cart:', error);
          showToast('Failed to add to cart. Please try again.', true);
        });
    });
  });

  // 页面结构变化时刷新 icon 数量
  const observer = new MutationObserver(() => {
    updateCartIconCount();
  });
  observer.observe(document.body, { childList: true, subtree: true });

  // 点击抽屉外区域关闭
  document.addEventListener('click', function (event) {
    const drawer = document.getElementById('CartDrawer');
    if (!drawer || !drawer.classList.contains('is-visible')) return;

    if (!drawer.contains(event.target)) {
      toggleCartDrawer(false);
    }
  });
});




// Trigger popup --- Start

/* ========= Signature Medispa — Quiz 按钮触发 Privy 弹窗 ========= */
(function () {
  // 结果页按钮的类（你截图中的 class）
  var QUIZ_BUTTON_SELECTOR = '.button-result-block--external';

  // Privy 左侧标签的几个可能选择器（不同布局/版本都尽量兼容）
  var PRIVY_TAB_SELECTOR = [
    '#privy-container .privy-tab',
    '.privy-tab[role="button"]',
    '.privy-side-tab-wrapper [role="button"]',
    '.privy-tab[tabindex]',
    '.privy-outer-container .privy-tab'
  ].join(', ');

  // 查找 Privy tab 元素
  function getPrivyTab() {
    return document.querySelector(PRIVY_TAB_SELECTOR);
  }

  // 实际打开弹窗：优先“模拟点击左侧标签”，失败再调用官方方法，最后兜底强显容器
  function openNewsletterPopup() {
    var tab = getPrivyTab();
    if (tab && typeof tab.click === 'function') {
      tab.click();
      return true;
    }

    if (window.Privy && typeof window.Privy.show === 'function') {
      window.Privy.show();
      return true;
    }

    // 兜底：直接显示容器（最后手段）
    var el = document.querySelector('#privy-container, .privy-outer-container');
    if (el) {
      el.style.display = 'block';
      el.style.visibility = 'visible';
      return true;
    }
    return false;
  }

  // 带重试的触发：防止 tab/Privy 脚本还未渲染
  function triggerWithRetry(maxTries, delay) {
    var tries = 0;
    (function attempt() {
      if (openNewsletterPopup()) return;
      if (++tries >= (maxTries || 10)) return; // 最多重试 10 次
      setTimeout(attempt, delay || 200);       // 每 200ms 重试一次
    })();
  }

  // 事件代理：拦截 Quiz 按钮点击（无论它是 <button> 还是 <a>）
  document.addEventListener('click', function (e) {
    var btn = e.target && e.target.closest(QUIZ_BUTTON_SELECTOR);
    if (!btn) return;

    // 阻止默认跳转和应用内部处理
    e.preventDefault();
    if (typeof e.stopPropagation === 'function') e.stopPropagation();
    if (typeof e.stopImmediatePropagation === 'function') e.stopImmediatePropagation();

    // 触发弹窗（带重试）
    triggerWithRetry(10, 200);
  }, true); // 捕获阶段，优先拦截

  // 可选：如果你给按钮配了 ?open-newsletter=1 的 URL，从其他页进来也自动弹
  try {
    var sp = new URLSearchParams(window.location.search);
    if (sp.get('open-newsletter') === '1') {
      if (document.readyState === 'complete' || document.readyState === 'interactive') {
        triggerWithRetry(10, 200);
      } else {
        window.addEventListener('DOMContentLoaded', function () { triggerWithRetry(10, 200); });
      }
      // 清理参数，避免刷新再次触发（可按需保留/删除）
      if (history.replaceState) history.replaceState({}, '', window.location.pathname + window.location.hash);
    }
  } catch (err) {}
})();

// Trigger popup --- End